// Product page script
Product = new Object();
Product.init = function () {
  Product.calculateDeliveryDate(5);
};

Product.calculateDeliveryDate = function (x) {
  var currentDate = new Date();
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(startDate, numDays) {
    var newDate = new Date(startDate);
    var businessDays = 0;

    while (businessDays < numDays) {
      newDate.setDate(newDate.getDate() + 1);
      // Check if the current day is a business day (Monday to Friday)
      if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
        businessDays++;
      }
    }
    return newDate;
  }

  // Calculate the first delivery date (skipping weekends)
  var firstDeliveryDate = addBusinessDays(currentDate, x);
  var firstDayName = days[firstDeliveryDate.getDay()];
  var firstDay = firstDeliveryDate.getDate();
  var firstMonth = months[firstDeliveryDate.getMonth()];

  var firstFormattedDate = firstDayName + ', ' + firstDay + ' ' + firstMonth;
  // Display the formatted first delivery date
  $('.pr_product_shipping_delivered__js').text(firstFormattedDate);
}



$(document).ready(function () {
  Product.init();

  $('.pr_product_accord_line').click(function () {
    $(this).find('.pr_accord_info').slideToggle();
    $(this).toggleClass('active');
  });

  $('.ox_mn_btn').click(function (evt) {
    evt.preventDefault();
    $('html, body').animate({
      scrollTop: $(".pr_product_container").offset().top
    }, 500);
  });

  $('.pb_main_button').click(function (evt) {
    evt.preventDefault();
    $('html, body').animate({
      scrollTop: $(".pr_product_container").offset().top
    }, 500);
  });

  // product quick add fixed/static depending if product section in view
  // const productMain = $('#product-main'),
  //       additionalSection = $('.shopify-section:has(.product-qadd)'),
  //       productQadd = $('.product-qadd');

  // let hasEntered = false, hasExited = false;

  // $(window).on('scroll', function() {
  //   const isInView = (el) => $(window).scrollTop() + $(window).height() > el.offset().top && 
  //                            $(window).scrollTop() < el.offset().top + el.outerHeight();

  //   const isProductMainInView = isInView(productMain);
  //   const isAdditionalSectionInView = isInView(additionalSection);

  //   if ((isProductMainInView || isAdditionalSectionInView) && !hasEntered) {
  //     hasEntered = true;
  //     hasExited = false;
  //     productQadd.css({'transform': 'translateY(100%) translateX(-50%)', 'position': 'unset', 'left': '0'});
  //     setTimeout(() => productQadd.css({'transform': 'unset'}), 300); // Adjust timeout based on animation duration
  //   }

  //   if (!(isProductMainInView || isAdditionalSectionInView) && !hasExited) {
  //     hasExited = true;
  //     hasEntered = false;
  //     productQadd.css({'position': 'fixed', 'transform': 'translateY(100%) translateX(-50%)', 'left': '50%'});
  //     setTimeout(() => productQadd.css('transform', 'translateY(0) translateX(-50%)'), 10);
  //   }
  // });

  // Helpers
  const extractDiscountPercentage = discount => discount ? parseInt((discount.match(/(\d+)%/) || [0, 0])[1], 10) : 0;
  const roundUpDecimal = (value, decimals) => Number(Math.ceil(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);



  const wrapperClass = '.pr_quantity_selector';
  const switchPillOn = $(wrapperClass + ':has(.switch-pill)').length;
  const simpleVariant = $('.pr_product_var.simple').length;
  const quickAddWrapper = '.product-qadd';

  // Separate variables for subscription and one-time purchase selections
  let selectedSub = !!$(wrapperClass + '.sub.active') || true;
  let selectedVar = $(wrapperClass + '.active .pr_product_var.active');
  let selectedFreq = simpleVariant ? selectedVar.data('plan-id') : 5710709016;
  let selectedQuan = 1;

  // Switch Sub/One-time
  let isOptionSyncing = false;

  $(wrapperClass + ':not(:has(.switch-pill))').click(function () {
    if (isOptionSyncing) return;

    $('#product-main ' + wrapperClass).removeClass('active');
    $(`${wrapperClass} .pr_product_outer, ${wrapperClass} .pr_product_simple_info`).hide();

    $(this).addClass('active'); 
    simpleVariant
      ? $(this).find('.pr_product_outer').css('display', 'flex')
      : $(this).find('.pr_product_outer').show();

    // if (simpleVariant) $(this).find('.pr_product_simple_info').show();

    selectedSub = $(this).hasClass('sub');

    const optionId = $('.pr_main_form .flavours .option-box.active').data('option-id');

    if (optionId) {
      isOptionSyncing = true;
      optionChangeById(optionId);
      isOptionSyncing = false;
    }

    $(this).hasClass('sub')? $('.sub-only').show(): $('.sub-only').hide();
    $(this).hasClass('one-time')? $('.onetime-only').show(): $('.onetime-only').hide();

  });


  // Switch Sub/One-time with Switch-Pill
  if (switchPillOn) {
    $('.switch-pill input').click(function () {
      const isChecked = $('#set1').is(':checked');
      log(isChecked);
      if (isChecked) {
        $('.pr_product_outer.sub').show();
        $('.pr_product_outer.one-time').hide()
      } else {
        $('.pr_product_outer.sub').hide();
        $('.pr_product_outer.one-time').show()
      }
      selectedSub = isChecked;
    });
  }

  // QUICK-ADD Switch Sub/One-time
  $('.product-qadd__heading-option').click(function () {
    const selectedOption = $(this).data('option');
    $(`${quickAddWrapper} .pr_quantity_selector, .product-qadd__heading-option`).removeClass('active');
    $(`${quickAddWrapper} .pr_quantity_selector.${selectedOption}`).addClass('active');
    $(quickAddWrapper).find('.pr_product_outer').css('display', 'flex');
    $(quickAddWrapper).find('.pr_product_simple_info').show();
    $(this).addClass('active');
    selectedSub = selectedOption === 'sub';
    if (!selectedSub) {
      $(`${quickAddWrapper} .pr_quantity_selector.${selectedOption} .pr_product_var.quantity`)[0].click();
    } else {
      // selectedQuan = 1; updatePrice('.one-time', selectedQuan, true)
    }
  });

  // Variant selection
  $(`${wrapperClass} .pr_product_var_outer_box`).click(function () {
    $(this).siblings().find('.pr_product_var').removeClass('active');
    selectedVar = $(this).find('.pr_product_var');
    log.table(selectedVar[0].dataset, "Variant Selection", "warning");
    selectedVar.addClass('active');
    const $activeQuantityVar = $(this).closest('.pr_quantity_selector').find(`.pr_product_simple_info .pr_product_var.quantity.active`);
    const discountPercentage = $activeQuantityVar.length > 0 ? extractDiscountPercentage($activeQuantityVar.data('discount')) : 0;
    if (simpleVariant && selectedVar.data('plan-id')) selectedFreq = selectedVar.data('plan-id'); // Simple Variant Frequency selection
    // updatePrice(selectedSub ? '.sub' : '.one-time', selectedSub ? 1 : selectedQuan, !!simpleVariant, !selectedSub ? discountPercentage : 0);
  });

  // Frequency selection
  $(`${wrapperClass + '.sub'} .variant__frequency-option`).click(function () {
    selectedFreq = $(this).data('plan-id');
    $(`${wrapperClass + '.sub'} .variant__frequency-option`).removeClass('active');
    $(this).addClass('active');
    // updatePrice();
  });

  // Quantity selection
  $(`.pr_product_simple_info .pr_product_var.quantity`).click(function (e) {
    e.stopPropagation();
    $(this).siblings().removeClass('active');
    $(this).addClass('active');    
    selectedQuan = $(this).data('quantity');

    const discountPercentage = extractDiscountPercentage($(this).data('discount'));
    // $(this).closest('.pr_quantity_selector').find('.pr_product_var_outer_box[data="flavor"] .pr_product_var.simple.active').trigger('click');
    var $parent = $(this).closest('.pr_quantity_selector');
    var $activeVar = $parent.find('.pr_product_var_outer_box[data="flavor"] .pr_product_var.simple.active');

    if ($activeVar.length) {
      $activeVar.trigger('click')
    } else {
      selectedVar = $parent.find('.pr_product_var.active.hidden');
      log.table({ ...selectedVar[0].dataset, "Discount Percentage": discountPercentage }, "Quantity Selection", "warning");
      // updatePrice('.one-time', selectedQuan, true, discountPercentage);
      // updatePrice('.sub ', selectedQuan, true, discountPercentage);
    }
  });

  function updatePrice(subclass = '.sub', times = 1, quickadd = false, discountPercentage = 0) {
    if (selectedVar && !switchPillOn) {
      let price = (selectedVar.data('price') * times / 100);
      let compare = selectedVar.data('compare-price') * times;
      let comparePrice = (compare / 100);

      // Apply discount percentage if provided
      if (discountPercentage > 0) {
        const discountMultiplier = (100 - discountPercentage) / 100;
        price = (price * discountMultiplier);
      }

      price = roundUpDecimal(price, 2);
      comparePrice = roundUpDecimal(comparePrice, 2);
      const saveAmount = roundUpDecimal(comparePrice - price, 2); // Ensure 2 trailing zeros

      var currencyNew = $('.pr_currency_selector__js').attr('data-currency').replace('<span class=money>', '').replace('0.00', '').replace('</span>', '').replace('0,00', '');
      var currency = currencyNew;

      log.table({ "Selling Plan": selectedSub ? 'Sub' : 'One-Time', "Variant Name": selectedVar.text().trim(), "Currency": currencyNew, "Price": price, "ComparePrice": comparePrice });

      if (quickadd) $('.pr_atc_btn.quickadd span').html(`<span class="money">` + currency + `${price}</span>`);
      const priceClass = wrapperClass + subclass + ' .pr_product_var_price_info';
      $(`${priceClass} span`).html(`<span class="money">` + currency + `${price}</span>`);
      $(`${priceClass} s`).html(`<span class="money">` + currency + `${comparePrice}</span>`).toggle(price !== comparePrice);

      $(`${priceClass} .pr_var_price_badge:not(.text_only)`).html(`You're saving <span class="money">` + currency + `${saveAmount}</span>`);
    }
  }

  if (!simpleVariant) $(`${wrapperClass} .variant__frequency-option`)[0].click();
  if (switchPillOn) $('.switch-pill input')[0].click();
  // updatePrice();

  $('.pr_atc_btn').click(function (evt) {
    evt.preventDefault();
    const id = selectedVar.data('id');
    const selling_plan = $('.pr_quantity_selector.sub.active  .variant__frequency-option.active').data('plan-id') ||  undefined;
    // const quantity = selectedSub ? 1 : selectedQuan;
    const quantity = parseInt($('.bundle-selection').find('.bundle-option.active').attr('data-quantity'),10) || 1;
    const items = [{ id, quantity, selling_plan }];

    // Add the items to the cart
    $.post('/cart/add.js', { items })
      .done(() => { window.cart_open(); window.cart_build() })
      .fail(() => alert('Error adding items to cart.'));
  });
  
    // Talatech code 
    $('body').on('click', '.pr_main_form .flavours .option-box', function () {
      const $clicked = $(this);
     $('.pr_main_form .flavours .option-box').removeClass('active');
      $clicked.addClass('active');
      optionChangeById($(this).data('option-id'));

    //   $('[data-new-money]').each(function () {
    //   const price = parseInt($(this).data('new-money'));    
    //   const $moneyEl = $(this).find('.money');

    //   if (!$moneyEl.length || !price) return;

    //   const finalPrice = price *  parseInt($('.bundle-option.acive').attr('data-quantity')) || 1;;
    //   $moneyEl.text(Shopify.formatMoney(finalPrice));
    // });

      const variantId = $(this).data('kc-variant');

      if ($(`.variant-details[data-kc-variant="${variantId}"]`).length) {
        $('.variant-details[data-kc-variant]').hide();
        $(`.variant-details[data-kc-variant="${variantId}"]`).show();
      }

    });

    function optionChangeById(optionId) {
      if (!optionId) return;

      const $targetOption = $(
        `.pr_quantity_selector.active [data-option-id="${optionId}"]`
      );

      if ($targetOption.length) {
        $targetOption.trigger('click');
      }
    }

  $('.bundle-selection .bundles .bundle-option').on('click', function () {
    var $parent = $(this).closest('.bundles');
    var qty = parseInt($(this).attr('data-quantity')) || 1;

    $parent.find('.bundle-option').removeClass('active');
    $(this).addClass('active');
    // if($('.pr_quantity_selector.one-time.active').length){
    //   $(`.pr_product_quantity_vars [data-quantity="${qty}"]`).trigger('click');
    // }

    $('[data-new-money]').each(function () {
      const price = parseInt($(this).data('new-money'));    
      const $moneyEl = $(this).find('.money');

      if (!$moneyEl.length || !price) return;

      const finalPrice = price * qty;
      $moneyEl.text(Shopify.formatMoney(finalPrice));
    });


  });

});

document.addEventListener("DOMContentLoaded", (event) => {
new Swiper('.video-gallery__slider', {
      slidesPerView: 3,
      spaceBetween: 16,
      navigation: {
        nextEl: '.video-gallery .swiper-button-next',
        prevEl: '.video-gallery .swiper-button-prev'
      },
      breakpoints: {
        0: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 3
        }
      }
    });


    document.querySelectorAll('.video-slide').forEach(function (slide) {
      slide.addEventListener('click', function () {
        const video = slide.querySelector('video');
        if (!video) return;

        // Pause all other videos
        document.querySelectorAll('.video-slide video').forEach(function (v) {
          if (v !== video) {
            v.pause();
            v.closest('.video-slide').classList.remove('active');
          }
        });

        // Toggle play / pause
        if (video.paused) {
          video.play();
          slide.classList.add('active');
        } else {
          video.pause();
          slide.classList.remove('active');
        }
      });
    });

});


var stickyButton = (() => {
    var mainPdp = document.querySelector('.product-right');
    if (mainPdp) {
        let submitBtn = mainPdp.querySelector('.pr_atc_btn')

        if (submitBtn) {
            var oldWrap = document.querySelector('.sticky-submit-wrap');
            if (oldWrap) oldWrap.remove();
    
            document.body.insertAdjacentHTML('beforeend', `<div class="sticky-submit-wrap pdp_btn_wpr">${submitBtn.outerHTML}</div>`);

            let stickyWrap = document.querySelector('.sticky-submit-wrap'),
                clonedBtn = stickyWrap.querySelector('.pr_atc_btn');

            clonedBtn.addEventListener('click', e => {
                e.preventDefault();
                submitBtn.click();
            });
            
            
            window.addEventListener('scroll', () => {
                let submitRect = submitBtn.getBoundingClientRect(),
                    headerHeight = document.querySelector('header').offsetHeight;

                if (submitRect.top + submitRect.height >= headerHeight) {
                    stickyWrap.classList.remove('active');
                } else {
                    stickyWrap.classList.add('active');
                }
            });
        }
    }
})

stickyButton()

document.querySelector('.loox-rating')?.addEventListener('click', () => {
  const target = document.querySelector('#looxReviews');
  if (!target) return;

  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});
